<template>
  <div class="row">
    <div class="col-12 mb-3">
      <section-title has-line title="Introducir Meta" />
      <validation-provider
        ref="goalDescValidator"
        v-slot="{ errors }"
        rules="required"
      >
        <custom-input
          v-model="goal.description"
          custom-error-msg="Favor escribir una descripción de la meta."
          :error="errors[0]"
          label="Introducir Meta:"
          maxlength="500"
          type="text"
        />
      </validation-provider>
    </div>
    <div
      v-if="showAreaSelection && hasAreaOptions && isPeiSigned"
      class="col-12"
    >
      <validation-provider ref="areaGoalValidator" v-slot="{ errors }">
        <area-selection
          ref="areaSelection"
          :area-options="areaOptions"
          :selected-areas="goal.areaSelection"
          @cancel-add="cancel"
          @cancel-update="cancel"
          @save-area-selection="goal.areaSelection = $event"
        />
        <goal-selection
          ref="goalSelection"
          :goal-options="filteredGoalOptions"
          :selected-goals="goal.goalSelection"
          @save-goal-selection="goal.goalSelection = $event"
        />
        <SelectedGoalsAreas :selected-goals="goal" />
        <ul v-if="errors && errors.length" class="text-danger mt-2">
          <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
        </ul>
      </validation-provider>
    </div>
    <div
      v-if="showAreaSelection && !hasAreaOptions && isPeiSigned"
      class="col-12"
    >
      <Error
        is-alert-mode
        message="Estudiante no cuenta con servicio educativo puede proceder a documentar metas y objetivos."
      />
    </div>
    <div class="col-12 mt-2 d-flex justify-content-end">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3"
        @click="cancel"
      />

      <action-button
        i="fa fa-save"
        text="Guardar"
        variant="success"
        @click="saveGoal"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import AreaSelection from '@/views/provider/referral-management/search/components/AreaSelection.vue';
import GoalSelection from '@/views/provider/referral-management/search/components/GoalSelection.vue';
import SelectedGoalsAreas from '@/views/provider/referral-management/search/components/SelectedGoalsAreas.vue';
import Error from '@/components/common/Error.vue';

export default {
  name: 'GoalForm',
  components: {
    Error,
    SectionTitle,
    CustomInput,
    ActionButton,
    AreaSelection,
    GoalSelection,
    SelectedGoalsAreas,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    showAreaSelection: {
      type: Boolean,
      default: false,
    },
    areaOptions: {
      type: Array,
      default: () => [],
    },
    goalOptions: {
      type: Array,
      default: () => [],
    },
    studentHasEducationalService: {
      type: Boolean,
      default: false,
    },
    isPeiSigned: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    goal: {
      description: null,
      areaSelection: [],
      goalSelection: [],
      objectives: [],
    },
    isEditing: false,
  }),
  computed: {
    hasAreaOptions() {
      return this.areaOptions.length > 0;
    },
    filteredGoalOptions() {
      if (!this.goal?.areaSelection?.length) {
        return this.goalOptions.filter((goal) =>
          this.goal.goalSelection?.some((selected) => selected.id === goal.id)
        );
      }

      const selectedIds = this.goal.areaSelection.map((a) => a.id);
      return this.goalOptions.filter((goal) => {
        const belongsToSelectedArea = selectedIds.includes(goal.areaId);
        const alreadySelected = this.goal.goalSelection.some(
          (selected) => selected.id === goal.id
        );
        return belongsToSelectedArea || alreadySelected;
      });
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(current) {
        if (current) {
          this.goal = current;
          this.isEditing = true;
        }
      },
    },
  },
  methods: {
    saveGoal() {
      var areaGoalSelectionValid = true;
      const errors = [];

      this.$refs.goalDescValidator.validate().then((valid) => {
        if (!valid) {
          areaGoalSelectionValid = false;
        }
      });

      if (!this.studentHasEducationalService) {
        if (
          this.showAreaSelection &&
          this.goal.areaSelection.length === 0 &&
          this.hasAreaOptions
        ) {
          areaGoalSelectionValid = false;
          errors.push('Favor seleccionar un área.');
        }

        if (
          this.showAreaSelection &&
          this.goal.goalSelection.length === 0 &&
          this.hasAreaOptions
        ) {
          areaGoalSelectionValid = false;
          errors.push('Favor seleccionar una meta.');
        }
      }

      if (!areaGoalSelectionValid) {
        this.$refs.areaGoalValidator?.setErrors(errors);
        return;
      }

      const event = this.isEditing ? 'edit-goal' : 'save-goal';
      this.$emit(event, this.goal);
    },
    cancel() {
      const event = !this.isEditing ? 'cancel-add' : 'cancel-update';
      this.$emit(event);
    },
  },
};
</script>
<style scoped lang="scss">
.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}
</style>
